<template>
  <dr-wrapper 
    v-if="isInEditorMode" 
    v-on="wrapOn" 
    v-bind="$props"
    :class="evaluateClasses(classes)">
    <v-container fluid class="pa-0">
      <v-card :style="{ 'height': height }">
        <v-card-text class="text-center">
          <p class="display-2">iframe</p>
        </v-card-text>
      </v-card>
    </v-container>
  </dr-wrapper>
  <iframe v-else-if="!isInEditorMode && isVisible" 
    :src="src"
    frameBorder="0" 
    :class="evaluateClasses(classes)"
    style="width:100%;"
    :style="{ 'height': height }"
    >
  </iframe>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  computed: {
    src() {
      return this.getDataSourceField(this.model.Src) || ''
    },
    height() {
      return this.model.Height
    }
  }
}
</script>

<style></style>
